module.exports = __webpack_public_path__ + "static/media/BankIDIcon.21ee0db8.svg";